import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Coupon from '../../Coupon';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';

interface CouponModalProps {
    open?: boolean;
    coupon?: any;
    onCancel?: () => void;
    setShowPage?: (page: string) => void;
}

const CouponModal: React.FC<CouponModalProps> = ({ open, coupon, onCancel, setShowPage }) => {
    const { useLang, useRouter, isMobile } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang('ecocredits');

    const getShowBtn = (coupon: any) => {
        const { ruleType, thirdUrl } = coupon || {};

        if (ruleType === 'COUPONS') return true;

        if (ruleType === 'THIRD_COUPONS' && thirdUrl) return true;

        return false;
    };

    const shopNow = (coupon: any) => {
        const { thirdUrl, ruleType, jumpUrl } = coupon;
        if (ruleType === 'THIRD_COUPONS') {
            if (isMobile) {
                router.push(thirdUrl);
                return;
            }
            window.open(thirdUrl, '_blank');
            return;
        }

        if (ruleType === 'COUPONS' && jumpUrl) {
            if (jumpUrl.startsWith('http')) {
                setTimeout(() => window.open(jumpUrl, '_blank'));
            } else {
                window.location.href = jumpUrl;
            }
            return;
        }

        if (isMobile) {
            router.push(`https://${locale}.ecoflow.com`);
            return;
        }
        setTimeout(() => {
            window.open(`https://${locale}.ecoflow.com`, '_blank');
        });
    };

    return (
        <EfModal className={`${css.efmodal} coupon over-height`} visible={open} onCancel={onCancel} zIndex={1200}>
            <div className="content">
                <h5 className="title">{t('prize_coupon_title')}</h5>
                <p className="sub-title">{t('prize_coupon_sub_title')}</p>
                <p className="sub-title">
                    {t.rich('prize_coupon_action', {
                        code: (children: string) => (
                            <i
                                className="btn"
                                onClick={() => {
                                    setShowPage?.('coupon_modal$2');
                                    onCancel?.();
                                }}
                            >
                                {children}
                            </i>
                        ),
                    })}
                </p>
                <div className="prompt_icon">
                    {!_isEmpty(coupon) && (
                        <Coupon
                            className="coupon-card"
                            coupon={coupon}
                            hideAmount={!['COUPONS', 'GIFT_CARD']?.includes(coupon?.ruleType)}
                            hideBtn
                            hideNote
                            showJumpBtn={!!coupon?.useUrl}
                        />
                    )}
                </div>
                <div className="confirm-rule-content">
                    <h5 className="confirm-rule-title">{t('rules')}</h5>
                    <ul className="confirm-rule-list">
                        {coupon?.noteList?.map((note: string, index: number) => (
                            <li key={index} className="confirm-rule-item">
                                {note}
                            </li>
                        ))}
                    </ul>
                </div>
                {getShowBtn(coupon) && (
                    <Button onClick={() => shopNow(coupon)} className="m-btn">
                        {t('prize_coupon_button')}
                    </Button>
                )}
            </div>
        </EfModal>
    );
};

export default CouponModal;
